/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "flowbite-react";
import arrowRightBlack from "../../../assets/arrowRight-black.svg";
import perfil from "../../../assets/img/usuario-negro.png";
//import ajuste from "../../../assets/img/ajustes.png";
import nota from "../../../assets/img/editar.png";
import ayuda from "../../../assets/img/ayuda.png";
import seguridad from "../../../assets/img/ayuda-seguridad.png";
import apoyo from "../../../assets/img/apoyo.png";
import { Logout } from "../../../utils/logout";
import { Link, useNavigate } from "react-router-dom";
import favoritoMenu from "../../../assets/img/favorito-menu.png";
import { MessageSquare } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { URL_API } from "../../../config/default";
import { myHeaders } from "../../../config/axios";

const User = ({ user }: any) => {
  const navigation = useNavigate();

  // Fetch conversations count
  const { data: conversationsData } = useQuery({
    queryKey: ["conversations"],
    queryFn: () => {
      return fetch(`${URL_API}/chat/conversations`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => {
        if (!res.ok) throw new Error("Error fetching conversations");
        return res.json();
      });
    },
    enabled: !!user,
  });

  const activeConversationsCount =
    conversationsData?.data?.filter((conv: any) => conv.status === "active")
      .length || 0;

  // Fetch favorites count
  const { data: favoritesData } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => {
      return fetch(`${URL_API}/favorites`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => {
        if (!res.ok) throw new Error("Error fetching favorites");
        return res.json();
      });
    },
    enabled: !!user,
  });

  const favoritesCount = favoritesData?.data?.length || 0;

  const menu = [
    {
      title: "Configuración de la cuenta",
    },
    {
      name: "Informacion personal",
      icon: perfil,
      dropdown: false,
      link: "/informacion",
      divider: false,
    },
    /*
    {
      name: "Cuenta",
      icon: ajuste,
      dropdown: false,
      link: "/cuenta",
      divider: false,
    },
    */
    {
      divider: true,
      hidden: false,
    },
    {
      title: "Viajeros",
      hidden: false,
    },
    {
      name: "Favoritos",
      icon: favoritoMenu,
      dropdown: false,
      link: "/favoritos",
      divider: false,
      hidden: false,
      badge: favoritesCount,
    },
    {
      name: "Reservas",
      icon: nota,
      dropdown: false,
      link: "/mis-reservas",
      divider: false,
      hidden: false,
    },
    {
      name: "Mensajes",
      icon: <MessageSquare />,
      dropdown: false,
      link: "/chat",
      divider: false,
      hidden: false,
      badge: activeConversationsCount,
    },
    /*
    {
      divider: true,
      hidden: false,
    },
    {
      title: "Modo",
      hidden: false,
    },
    {
      name: "Convertite en el anfitrion de un alojamiento",
      icon: nota,
      dropdown: false,
      link: `/modo/${user.mode}`,
      divider: false,
      hidden: user.mode == "owner" ? true : false,
    },
    {
      name: "Cambiar al modo viajero",
      icon: nota,
      dropdown: false,
      link: `/modo/${user.mode}`,
      divider: false,
      hidden: user.mode == "tenant" ? true : false,
    },
    */
    {
      divider: true,
    },
    {
      title: "Ayuda",
    },
    {
      name: "Soporte Tecnico",
      icon: ayuda,
      dropdown: false,
      link: "/soporte-tecnico",
      divider: false,
    },
    {
      name: "Privacidad, Terminos y condiciones",
      icon: seguridad,
      dropdown: false,
      link: "/privacidad-y-terminos-de-uso",
      divider: false,
      hidden: false,
    },
    {
      name: "Recursos de anfitrion",
      icon: apoyo,
      dropdown: false,
      link: "/recursos-anfitrion",
      divider: false,
    },
  ];

  return (
    <div className="w-full h-full  flex items-center">
      <Link
        to={`/dashboard`}
        className="hidden lg:flex justify-center items-center btn w-auto h-full btn-filled-2" 
        style={{borderRadius: "50px"}}
      >
        <span style={{fontSize: "12px"}}>
          Modo anfitrión
        </span>
      </Link>

      <Dropdown
        arrowIcon={false}
        label={
          <button className="focus:outline-none focus:ring-0 ring-0 outline-none text-primary font-bold text-xl bg-white rounded-2xl w-[30px] h-[30px] flex items-center justify-center overflow-hidden">
            {user.image ? (
              <img src={user?.image} alt="" className="object-cover" />
            ) : (
              "C"
            )}
          </button>
        }
        className="focus:outline-none focus:ring-0 ring-0 outline-none border-0 rounded-lg py-5 px-3 w-[350px]  bg-white "
        style={{
          border: "0px",
          background: "transparent",
        }}
      >
        <Dropdown.Item>
          <div className="font-bold text-primary mb-2 flex items-center">
            <div className="text-primary font-bold text-xl bg-white border rounded-2xl w-[30px] h-[30px] items-center flex justify-center me-2 overflow-hidden">
              <img src={user?.image} alt="" className="object-cover" />
            </div>
            {`${user.firstname} ${user.lastname}`}
          </div>
        </Dropdown.Item>

        {menu.map((m: any, index: any) => {
          if (m.title) {
            return (
              <Dropdown.Item className={`${m.hidden ? "hidden" : ""}`}>
                <div className={`font-bold text-black mb-3`} key={index}>
                  {m.title}
                </div>
              </Dropdown.Item>
            );
          }
          if (m.divider) {
            return (
              <Dropdown.Item
                key={index}
                className={`${m.hidden ? "hidden" : ""}`}
              >
                <hr
                  className={`my-3 ${m.hidden ? "hidden" : ""}`}
                  style={{ background: "#0000" }}
                />
              </Dropdown.Item>
            );
          }
          return (
            <Dropdown.Item className={`w-full ${m.hidden ? "hidden" : ""}`}>
              <label
                className={`w-full flex justify-between items-center ${
                  m.hidden ? "hidden" : ""
                }`}
                key={index}
              >
                <Link
                  className="flex items-center text-start font-normal"
                  to={m.link}
                >
                  {typeof m.icon == "string" ? (
                    <img src={m.icon} style={{ width: "20px" }} alt="" />
                  ) : (
                    m.icon
                  )}
                  <span className="ms-2">{m.name}</span>
                  {m.badge !== undefined && m.badge > 0 && (
                    <span className="ms-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
                      {m.badge}
                    </span>
                  )}
                </Link>
                <img src={arrowRightBlack} alt="" />
              </label>
            </Dropdown.Item>
          );
        })}

        <div className="w-full">
          <label
            className="
cursor-pointer
w-full
mt-3
bg-transparent 
hover:bg-primary
text-dark-700 
font-semibold 
hover:text-white 
py-2 px-4 
border 
border-dark-500 
hover:border-transparent 
rounded
block
text-center"
          >
            Cerrar sesión
            <button
              className="hidden"
              onClick={() => Logout(navigation)}
            ></button>
          </label>
        </div>
      </Dropdown>
    </div>
  );
};

export default User;
